'use client'

import { getCookie } from 'shared/libs/storage/cookie'

const prodModeAdjust = process.env.NEXT_PUBLIC_ADJUST_PROD === 'true'
const isWebview = getCookie('isWebview')
export const initAdjust = async () => {
  if (prodModeAdjust && isWebview) {
    if (!window.initAdjust) {
      const Adjust = (await import('@adjustcom/adjust-web-sdk')).default
      Adjust.initSdk({
        appToken: process.env.NEXT_PUBLIC_ADJUST || '',
        environment: prodModeAdjust ? 'production' : 'sandbox',
      })
      void Adjust.trackEvent({
        eventToken: 'ml9q6b',
      })
      window.initAdjust = true
    }
  }

  return null
}
export const trackAdjustEventAddToCart = async () => {
  const Adjust = (await import('@adjustcom/adjust-web-sdk')).default
  void Adjust.trackEvent({
    eventToken: 'qcjxgy',
  })
}
export const trackAdjustEventSearchProduct = async () => {
  const Adjust = (await import('@adjustcom/adjust-web-sdk')).default
  void Adjust.trackEvent({
    eventToken: '96j1vg',
  })
}
export const trackAdjustEventProduct = async () => {
  const Adjust = (await import('@adjustcom/adjust-web-sdk')).default
  void Adjust.trackEvent({
    eventToken: '3r03w1',
  })
}

export const trackAdjustEventMbankPay = async () => {
  const Adjust = (await import('@adjustcom/adjust-web-sdk')).default
  void Adjust.trackEvent({
    eventToken: '5usdv4',
  })
}
export const trackAdjustEventMplusPay = async () => {
  const Adjust = (await import('@adjustcom/adjust-web-sdk')).default
  void Adjust.trackEvent({
    eventToken: '3inl7h',
  })
}
